<template>
  <div
    class="tw-flex tw-w-full tw-max-w-full tw-cursor-pointer tw-items-center tw-text-grey-medium hover:tw-text-blackest"
  >
    <div class="tw-flex tw-items-center tw-gap-2 tw-truncate tw-text-xs">
      <div
        v-if="item.status === 'Blacklisted'"
        class="tw-inline-block tw-rounded tw-bg-status-error tw-px-1 tw-py-px tw-text-2xs tw-text-white"
      >
        Blocked
      </div>
      <div
        v-else-if="item.status === 'Whitelisted'"
        class="tw-inline-block tw-rounded tw-bg-status-success tw-px-1 tw-py-px tw-text-2xs tw-text-white"
      >
        Allowed
      </div>
      <div
        v-else
        class="tw-inline-block tw-rounded tw-bg-status-archived tw-px-1 tw-py-px tw-text-2xs tw-text-white"
      >
        No status
      </div>
    </div>
  </div>
</template>
<script>
import ListCellDefault from '@/components/list/cell/default.vue'

export default {
  name: 'ListCellCreativeStatus',
  extends: ListCellDefault,
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
}
</script>
